// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"dc491597b47754bbe7fe","245":"3fb0dda50bb642ba6580","452":"ae818de597a3887c230a","453":"5720a7690078f460cdf3"}[chunkId] + ".js";
};